var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 15.6A4.8 4.8 0 0 1 5 14.2h8a4.8 4.8 0 0 1 4.8 4.8v2a.8.8 0 1 1-1.6 0v-2a3.2 3.2 0 0 0-3.2-3.2H5A3.2 3.2 0 0 0 1.8 19v2a.8.8 0 0 1-1.6 0v-2c0-1.27.5-2.5 1.4-3.4ZM9 3.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4ZM4.2 7a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0ZM19.23 14.93a.8.8 0 0 1 .97-.57A4.8 4.8 0 0 1 23.8 19v2a.8.8 0 0 1-1.6 0v-2a3.2 3.2 0 0 0-2.4-3.1.8.8 0 0 1-.57-.97ZM15.22 2.93a.8.8 0 0 1 .98-.58 4.8 4.8 0 0 1 0 9.3.8.8 0 0 1-.4-1.55 3.2 3.2 0 0 0 0-6.2.8.8 0 0 1-.58-.97Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.0b4ec4389b192ccfc1500df2173130f9.svg";
export { ForwardRef as ReactComponent };